import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice from '../../../../images/raw_material/rice.png';
import vehicle from '../../../../images/vehicle/default_vehicle.png';
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
const Consumption = ({ show, onClose, data, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const vehicleID = data.sno;

    // service type 
    const [servicetypeoption, setServicetype] = useState([]);
    const [service_type, setServiceType] = useState('');
    useEffect(() => {
        const fetchdata = async () => {
            try {
            const response = await axios.get(`${baseURL}/dropdown/servicetype`);
            const formatted = response.data.data.map(item => ({
                value: item.sno,
                label: item.servicetype_name,
            }));
            setServicetype(formatted);
            } catch (error) {
            console.error('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const handleservicetypechange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value).join(','); // converts to "1,5,9"
        setServiceType(ids);
    }

    // usestates for fields
    const [service_notes, setServicenotes] = useState('');
    const [service_amount, setServiceamount] = useState('');
    const [service_date, setServicedate] = useState(null);
    const [service_dateDisp, setServicedateDisp] = useState(null);
    const [description, setdescription] = useState('');

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!service_type) {
            newErrors.type = "This Field is Required.";
        }

        if (!service_notes) {
            newErrors.notes = "This Field is Required.";
        }

        if (!service_amount) {
            newErrors.amt = "This Field is Required.";
        }

        if (!service_date) {
            newErrors.date = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }
        
        let postdata = {
            branch_id: branch_id,
            vehicle_id: vehicleID,
            service_type: service_type,
            service_notes: service_notes,
            service_amount: service_amount,
            upcomming_maintanence_date: service_date,
            description: description,
        }
        
        axios.post(`${baseURL}/manage_maintenance`, postdata)
            .then(response => {
                refresh();
                onClose();
                toast.success("Schedule Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Schedule Creation Failed");
            });
            
    };

    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Maintenance Schedule</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className='col-lg-2'>
                            <div className="d-flex align-items-center">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={(imgBaseUrl && data.vehicle_image) ? imgBaseUrl + '/' + data.vehicle_image : vehicle} className=''>
                                        <img src={(imgBaseUrl && data.vehicle_image) ? imgBaseUrl + '/' + data.vehicle_image : vehicle} alt={data.vehicle_brand + ' ' + data.vehicle_model} className='w-100px h-120px' />
                                    </div>
                                </LightGallery>
                            </div>
                        </div>
                        <div className='col-lg-10'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Category</label>
                                    <label className='text-black fs-6 font-w500'>{data.category_name}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Brand</label>
                                    <label className='text-black fs-6 font-w500'>{data.vehicle_brand}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Number</label>
                                    <label className='text-black fs-6 font-w500'>{data.vehicle_number}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Registration Date</label>
                                    <div>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1'>{formatDate(data.registration_date)}</Badge>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Service date</label>
                                    <label className='text-black fs-6 font-w500'>{formatDate(data.upcoming_maintenance_date)}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 mb-3'>
                            <label className="text-black font-w500 fs-7">Service Type<span className="required">*</span></label>
                            <Select placeholder='Select Service Type'
                                onChange={handleservicetypechange}
                                options={servicetypeoption}
                                isMulti
                            />
                            {errors.type && <div className="text-danger fs-8 mt-1">{errors.type}</div>}
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Service Notes<span className="required">*</span></label>
                            <textarea rows={4} className="form-control mw-auto" name="comment" placeholder="Description" 
                                maxLength={300}
                                value={service_notes}
                                onChange={(e) => setServicenotes(e.target.value)}
                            />
                            {errors.notes && <div className="text-danger fs-8 mt-1">{errors.notes}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Service Amount<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Service Amount" 
                                maxLength={10}
                                value={service_amount}
                                onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                    setServiceamount(onlyNums);
                                }}
                            />
                            {errors.amt && <div className="text-danger fs-8 mt-1">{errors.amt}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className="form-control mw-auto" name="comment" placeholder="Description" 
                                maxLength={255}
                                value={description}
                                onChange={(e) => setdescription(e.target.value)}
                            />
                        </div>
                        <label className="text-black font-w500 fs-5 mb-3">UpComing Maintenance Schedule</label>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7 ">Upcoming Maintenance Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Upcoming Maintenance Date'
                                    format="DD-MM-YYYY"
                                    value={service_dateDisp}
                                    minDate={new Date().setHours(0,0,0)}
                                    onChange={(date) => {
                                        setServicedateDisp(date);
                                        const formattedDate = date.format('YYYY-MM-DD');
                                        setServicedate(formattedDate);
                                    }}
                                />
                            </div>
                            {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Maintenance Schedule<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Consumption;
